import { QueryClient } from 'react-query';

let queryClient = null;

const getQueryClient = (): QueryClient => {
    queryClient =
        queryClient ||
        new QueryClient({
            defaultOptions: {
                queries: {
                    refetchOnWindowFocus: false,
                },
            },
        });

    return queryClient;
};

export { getQueryClient };
